import { Action } from 'redux';

import { UpdateDataManagementAwarenessSettings } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';


export interface UpdateDataManagementAwarenessAction extends Action {
  showPrepConductorAwareness: boolean;
  showCatalogAwareness: boolean;
}


export function updateDataManagementAwarenessAction(showPrepConductorAwareness: boolean, showCatalogAwareness: boolean): UpdateDataManagementAwarenessAction {
  return {
    type: UpdateDataManagementAwarenessSettings,
    showPrepConductorAwareness,
    showCatalogAwareness,
  };
}

export const isUpdateDataManagementAwarenessAction = isActionFactory<UpdateDataManagementAwarenessAction>(UpdateDataManagementAwarenessSettings);
